import { observer } from "mobx-react";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import UserListing from "./users-listing";
import { useStores } from "../../stores/root-store";
import UserForm from "./user-form";
import { UserRoleEnum } from "../../stores/index.d";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const UsersIndex = observer(() => {
  const { userStore } = useStores();
  const { editUser, setEditUser, fetchUsers, users } = userStore;
  const [showUserForm, setShowUserForm] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);

  const handleUserFormClose = (show: boolean) => {
    setShowUserForm(show);
    if (!show) setEditUser(null);
  };

  useEffect(() => {
    if (editUser) setShowUserForm(editUser?.id != null);
  }, [editUser]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const customersList = useMemo(() => {
    return users.filter((p) =>
      p.roles.some((r) => r === UserRoleEnum.Customer)
    );
  }, [users]);

  const staffList = useMemo(() => {
    return users.filter((p) =>
      p.roles.some(
        (r) => r === UserRoleEnum.ShopUser || r === UserRoleEnum.Admin
      )
    );
  }, [users]);

  const handleTabChange = (tab: number) => {
    setSelectedTab(tab);
  };

  return (
    <div className="container mt-3">
      <ul className="nav nav-tabs nav-fill mb-3" id="addons" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            data-mdb-tab-init
            className={`nav-link ${
              selectedTab === 1 ? "active bg-default text-white" : ""
            }`}
            href="#addons-tabs-1"
            role="tab"
            aria-controls="addons-tabs-1"
            aria-selected="true"
            onClick={() => handleTabChange(1)}
          >
            Customers
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            data-mdb-tab-init
            className={`nav-link ${
              selectedTab === 2 ? "active bg-default text-white" : ""
            }`}
            href="#opts-tabs-2"
            role="tab"
            aria-controls="opts-tabs-2"
            aria-selected="false"
            onClick={() => handleTabChange(2)}
          >
            Shop Users
          </a>
        </li>
      </ul>
      <div className="tab-content" id="addons-content">
        {selectedTab === 1 && (
          <div
            className="tab-pane fade show active"
            id="addons-tabs-1"
            role="tabpanel"
            aria-labelledby="addons-tabs-1"
          >
            <div className="row mb-3">
              <h5 className="mb-0 text-start">Manage Customers</h5>
            </div>
            <UserListing users={customersList} isCustomerPageRequest={true} />
          </div>
        )}
        {selectedTab === 2 && (
          <div
            className="tab-pane fade show active"
            id="opts-tabs-2"
            role="tabpanel"
            aria-labelledby="opts-tab-2"
          >
            <div className="row mb-3">
              <h5 className="mb-0 text-start">
                Manage Shop Users
                <Button
                  onClick={() => setShowUserForm(true)}
                  className="btn-default float-end"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  New User
                </Button>
              </h5>
            </div>
            <UserListing users={staffList} isCustomerPageRequest={false} />
          </div>
        )}
      </div>

      {showUserForm && (
        <UserForm show={showUserForm} setShowModal={handleUserFormClose} />
      )}
    </div>
  );
});

export default UsersIndex;
